import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
import Header from './Header';
import Footer from './Footer';
import Services from './Services';
import SEOHead from './SEOHead';
import { Users, Clock, Award } from 'lucide-react';

const ServicesPage = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title={language === 'en' ? 'Professional Services - LAIMU Trantor | Implementation & Support' : 'Servicios Profesionales - LAIMU Trantor | Implementación y Soporte'}
        description={language === 'en' ? 'Expert consulting, implementation, and support services for LAIMU Trantor. From setup to success, we guide your digital transformation journey.' : 'Servicios expertos de consultoría, implementación y soporte para LAIMU Trantor. Desde la configuración hasta el éxito, guiamos tu viaje de transformación digital.'}
        url="/services"
      />
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-gray-50 via-white to-blue-50">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <div className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium mb-6" style={{ backgroundColor: '#e0f2fe', color: '#115d7b' }}>
              <Award className="w-4 h-4 mr-2" />
              {language === 'en' ? 'Professional Service Excellence' : 'Excelencia en Servicios Profesionales'}
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              {language === 'en' ? 'Your Success is Our Mission' : 'Tu Éxito es Nuestra Misión'}
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              {language === 'en' 
                ? 'From initial consultation to ongoing support, our expert team ensures your LAIMU Trantor implementation delivers maximum value and ROI.'
                : 'Desde la consulta inicial hasta el soporte continuo, nuestro equipo experto asegura que tu implementación de LAIMU Trantor entregue máximo valor y ROI.'
              }
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/demo"
                className="px-8 py-4 text-white rounded-lg transition-colors font-bold text-lg shadow-lg"
                style={{ backgroundColor: '#115d7b' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#0f5269'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#115d7b'}
              >
                {language === 'en' ? 'Schedule Consultation' : 'Agendar Consulta'}
              </a>
              <a
                href="#contact"
                className="px-8 py-4 border-2 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-bold text-lg"
                style={{ borderColor: '#115d7b' }}
              >
                {language === 'en' ? 'Contact Expert' : 'Contactar Experto'}
              </a>
            </div>
          </div>

          {/* Service Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="w-8 h-8 text-blue-600" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">500+</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">
                {language === 'en' ? 'Successful Implementations' : 'Implementaciones Exitosas'}
              </h3>
              <p className="text-gray-600 text-sm">
                {language === 'en' ? 'Across multiple industries' : 'En múltiples industrias'}
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Clock className="w-8 h-8 text-green-600" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">2</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">
                {language === 'en' ? 'Weeks Average Setup' : 'Semanas Promedio de Configuración'}
              </h3>
              <p className="text-gray-600 text-sm">
                {language === 'en' ? 'From start to go-live' : 'Desde inicio hasta puesta en marcha'}
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="w-8 h-8 text-purple-600" />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-2">98%</div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">
                {language === 'en' ? 'Client Satisfaction' : 'Satisfacción del Cliente'}
              </h3>
              <p className="text-gray-600 text-sm">
                {language === 'en' ? 'Would recommend us' : 'Nos recomendarían'}
              </p>
            </div>
          </div>
        </div>
      </section>

      <Services />
      <Footer />
    </div>
  );
};

export default ServicesPage;